import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	allAddOns: [],
	guestId: null,
	selectedAddOns: [],
	extendStay: {},
	earlyCheckInTime: "",
	lateCheckOutTime: "",
	addOnHistory: "",
	extendStayStatus: "",
	guestAddons: [],
	guestCheckInOutRequests: [],
};

const addOnsSlice = createSlice({
	name: "addOn",
	initialState: initialState,
	reducers: {
		setGuestId: (state, action) => {
			state.guestId = action.payload;
		},
		setAllAddOns: (state, action) => {
			state.allAddOns = action.payload;
		},
		setSelectedAddOns: (state, action) => {
			state.selectedAddOns = action.payload;
		},
		addSelectedAddOn: (state, action) => {
			const exists = state.selectedAddOns.find(
				(addOn) => addOn._id === action.payload._id,
			);
			if (!exists) {
				state.selectedAddOns.push(action.payload);
			}
			// Update the relevant arrays directly when a request is made so UI reflects it immediately
			if (action.payload.addOnType !== "CustomAddon") {
				if (action.payload.name?.toLowerCase().includes("early")) {
					state.guestCheckInOutRequests.push({
						checkInOutRequestId: action.payload._id,
						requestType: "earlyCheckIn",
						requestStatus: "Requested"
					});
				} else if (action.payload.name?.toLowerCase().includes("late")) {
					state.guestCheckInOutRequests.push({
						checkInOutRequestId: action.payload._id,
						requestType: "lateCheckOut",
						requestStatus: "Requested"
					});
				}
			} else {
				state.guestAddons.push({
					addOnsId: action.payload._id,
					requestStatus: "Requested"
				});
			}
		},
		setExtendStay: (state, action) => {
			state.extendStay = action.payload;
		},
		setEarlyCheckInTime: (state, action) => {
			state.earlyCheckInTime = action.payload;
		},
		setLateCheckOutTime: (state, action) => {
			state.lateCheckOutTime = action.payload;
		},
		filterCheckInOutRequsts: (state, action) => {
			action.payload.forEach((req) => {
				// Find if the addon exists in selectedAddOns array
				const existingAddOnIndex = state.selectedAddOns.findIndex(
					(addon) => addon._id === req.checkInOutRequestId,
				);

				// If the addon exists
				if (existingAddOnIndex !== -1) {
					const addOn = state.selectedAddOns[existingAddOnIndex]; // Get the add-on object

					if (req.requestStatus === "Declined") {
						state.selectedAddOns.splice(existingAddOnIndex, 1); // Remove the add-on

						// Check if the name contains "early" to reset earlyCheckInTime or lateCheckOutTime
						if (addOn.name.toLowerCase().split(" ").includes("early")) {
							state.earlyCheckInTime = ""; // Remove earlyCheckInTime
						} else {
							state.lateCheckOutTime = ""; // Remove lateCheckOutTime
						}
					} else if (req.requestStatus === "Accepted") {
						addOn.status = "Accepted"; // Update status to 'Accepted'
					}
				}
			});
		},
		filterAddOnRequests: (state, action) => {
			state.addOnHistory = action.payload;

			action.payload.forEach((req) => {
				const existingAddOnIndex = state.selectedAddOns.findIndex(
					(addon) => addon._id === req.addOnsId,
				);

				// If the addon exists and its requestStatus is 'Declined', remove it from selectedAddOns
				if (existingAddOnIndex !== -1) {
					if (req.requestStatus === "Declined") {
						state.selectedAddOns.splice(existingAddOnIndex, 1); // Remove the addon
					} else if (req.requestStatus === "Accepted") {
						// If 'Accepted', add status field and set it to 'Accepted'
						state.selectedAddOns[existingAddOnIndex].status = "Accepted";
					}
				}
			});
		},
		filterHouseKeepingRequest: (state, action) => {
			action.payload.forEach((req) => {
				if (req.requestStatus === "Declined") {
					state.selectedAddOns.splice(req._id, 1); // Remove the addon
				} else if (req.requestStatus === "Accepted") {
					// If 'Accepted', add status field and set it to 'Accepted'
					state.selectedAddOns[req._id].status = "Accepted";
				}
			});
		},
		addExtendStayStatus: (state, action) => {
			state.extendStayStatus = action.payload;
		},
		setGuestAddons: (state, action) => {
			state.guestAddons = action.payload;
		},
		setGuestCheckInOutRequests: (state, action) => {
			state.guestCheckInOutRequests = action.payload;
		},
	},
});

export const {
	setGuestId,
	setAllAddOns,
	setSelectedAddOns,
	addSelectedAddOn,
	setExtendStay,
	setEarlyCheckInTime,
	setLateCheckOutTime,
	filterCheckInOutRequsts,
	filterAddOnRequests,
	addExtendStayStatus,
	setGuestAddons,
	setGuestCheckInOutRequests,
	filterHouseKeepingRequest,
} = addOnsSlice.actions;
export default addOnsSlice.reducer;
